import { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../assets/img/image-1@2x.png';
import helpIcon from '../../assets/img/Help-Icon.svg';
import buttonLogout from '../../assets/img/button-logout.svg';
import { CalendarIcon, ArticleIcon } from '../../assets/svg';
import { clearAuth } from '../../store/auth/slice';

const Participant = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const { org_short_name } = useSelector(state => state.auth);
  const [menuOpen, setMenuOpen] = useState(false);

  const logoutHandler = () => {
    dispatch(clearAuth())
  }

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen bg-[#f9fafb] font-[Inter]">

      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-30 flex items-center justify-between bg-white border-b border-[#d9d9d9] px-4 py-3">
        <button
          type="button"
          aria-label="Открыть меню"
          onClick={() => setMenuOpen(true)}
          className="flex h-10 w-10 items-center justify-center rounded-[8px] border border-solid border-[#e5e7eb] bg-white"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <img src={logo} alt="" className="h-9 w-auto object-contain" />
        <img
          className="h-10 w-10 rounded-[10px] cursor-pointer"
          alt=""
          src={buttonLogout}
          onClick={logoutHandler}
        />
      </div>

      {menuOpen && (
        <div
          className="lg:hidden fixed inset-0 z-40 bg-black/40"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-screen w-[20rem] sm:w-[22rem] lg:w-[24.5rem] bg-white border-r border-[#d9d9d9] flex flex-col justify-between py-[1.5rem] px-[1.5rem] lg:py-[1.875rem] lg:px-[3.125rem] box-border z-50 shrink-0 overflow-y-auto transition-transform duration-300 ${
          menuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        <div className="flex flex-col gap-[1.5rem] lg:gap-[2rem]">
          <div className="flex items-center justify-between">
            <img
              className="w-[6rem] h-[3.875rem] lg:w-[7.5rem] lg:h-[4.875rem] object-cover"
              loading="lazy"
              alt=""
              src={logo}
            />
            <button
              type="button"
              aria-label="Закрыть меню"
              onClick={() => setMenuOpen(false)}
              className="lg:hidden flex h-9 w-9 items-center justify-center rounded-[8px] hover:bg-[#f3f4f6]"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <div className="flex flex-col gap-[0.312rem] text-[#000]">
            <div className="font-medium text-[0.938rem] lg:text-[1rem] leading-snug">
              Система регистрации и ведения результатов олимпиад и конкурсов
            </div>
            <div className="text-[0.812rem] lg:text-[0.875rem]">
              довузовских общеобразовательных организаций
            </div>
          </div>
          <nav className="flex flex-col gap-[0.5rem]">
            <NavLink
              to="events"
              replace
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-[1rem] lg:py-[1.125rem] rounded-[10px] text-[0.938rem] lg:text-[1rem] font-medium transition-colors ${
                  isActive
                    ? 'bg-[#CCFBF1] text-[#0D9488]'
                    : 'text-[#475569] hover:bg-gray-50'
                }`
              }
            >
              <CalendarIcon />
              Доступные мероприятия
            </NavLink>
            <NavLink
              to="requests"
              replace
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-[1rem] lg:py-[1.125rem] rounded-[10px] text-[0.938rem] lg:text-[1rem] font-medium transition-colors ${
                  isActive
                    ? 'bg-[#CCFBF1] text-[#0D9488]'
                    : 'text-[#475569] hover:bg-gray-50'
                }`
              }
            >
              <ArticleIcon />
              Поданные заявки
            </NavLink>
          </nav>
        </div>

        <div className="mt-6 rounded-[10px] bg-[#f8fafc] flex items-center p-[1rem] lg:p-[1.5rem] gap-[1rem] text-[#171717]">
          <img
            className="h-[2.5rem] w-[2.5rem] rounded-[10px] shrink-0"
            alt=""
            src={helpIcon}
          />
          <div className="flex flex-col gap-[0.312rem]">
            <div className="font-medium text-[0.938rem] lg:text-[1rem]">Нужна помощь?</div>
            <div className="text-[0.812rem] lg:text-[0.875rem] text-[#848484]">
              Свяжитесь с поддержкой
            </div>
          </div>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-h-screen lg:ml-[24.5rem] relative">
        <header
          className="hidden lg:flex absolute top-0 right-0 items-start justify-end gap-[1.25rem] pt-[1.875rem] pr-[3.125rem] pb-[1.5rem] z-10 bg-transparent"
        >
          <div className="flex items-start gap-[1.875rem]">
            <div className="flex flex-col gap-[0.25rem] text-right">
              <h5 className="m-0 text-[1.25rem] font-semibold tracking-[-0.03px] leading-tight">
                Личный кабинет участника
              </h5>
              <div className="text-[.75rem]">{org_short_name}</div>
            </div>
            <img
              className="h-[3.75rem] w-[3.75rem] rounded-[10px] cursor-pointer"
              loading="lazy"
              alt=""
              src={buttonLogout}
              onClick={logoutHandler}
            />
          </div>
        </header>

        <div className="lg:hidden mt-[3.5rem] px-4 pt-4 pb-2">
          <h5 className="m-0 text-[1.125rem] font-semibold leading-tight">
            Личный кабинет участника
          </h5>
          <div className="text-[.75rem] text-[#6b7280]">{org_short_name}</div>
        </div>

        <main className="flex-1 pt-[1rem] lg:pt-[2.5rem] px-4 sm:px-6 lg:px-[3.125rem] pb-[2rem] lg:pb-[3.125rem]">
          <Outlet />
        </main>
      </div>

    </div>
  );
};

export default Participant;
